import { createChipWihFadingBackgroundVariations } from '~/src/dash/components/model-chip';
import { publicaColors } from '~/src/dash/utils/colors';

export const ChipAdserverCreativeBannerTier = createChipWihFadingBackgroundVariations(
  publicaColors.jungleGreen,
  publicaColors.mint,
  publicaColors.mint,
  publicaColors.mint,
  true,
  true,
);
